import React, { Component } from "react";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import CtBtn from "./CustomTool/CtBtn";
import TableList from "./CustomTool/TableList";
import { withRouter } from "../HOC/withRouter";
import { connect } from "react-redux";
import {
  mapSetActiveMenu_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { Box, Grid } from "@mui/material";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import CtCheckBox from "./CustomTool/CtCheckBox";
import { Delete, Edit } from "@mui/icons-material";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { fetchStoreMaster } from "./API";
import Progress from "./CustomTool/Progress";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import CtART from "./CustomTool/ResponsiveTable";

class StoreMaster extends Component {
  state = {
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      // { id: 'bint_srno', label: 'SR NO' },
      { id: "vac_storename", label: "Store Name" },
      { id: "int_default", label: "Default Store" },
    ],
    columnsdata: [
      { accessorKey: "vac_storename", header: "Store Name" },
      { accessorKey: "int_default", header: "Default Store" },
      { accessorKey: "vac_default", header: "Default Store" },
    ],
    keyColumn: ["bint_acid", "vac_storename", "int_default"],

    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "StoreMaster:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "StoreMaster:",
        actionType: "AlertResponsive",
      },
    ],
    formData: {
      bint_acid: "",
      EditStoreName: "",
      txtStoreName: "",
      chkDefaultStore: "",
    },
    searchData: {
      vac_storename: "",
      int_default: "",
    },
    rows: [],
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    {
      !this.props.showHeading &&
        (document.title = "RiTe Account : Store Master");
    }
    this.props.setActiveMenu("StoreMaster");
    this.ShortCut();
    this.setSearchColumns();
    this.props.verifyUserID(
      this.getInfo,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  componentWillUnmount() {
    this.removeShortCut();
  }
  //#endregion Component

  //#region Handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleOnChkChange = (e) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [e.target.name]: e.target.checked,
        },
      }
      // () => {
      //   console.log(
      //     "this.state.formData.chkDefaultStore after change",
      //     this.state.formData.chkDefaultStore
      //   );
      // }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        // console.log("int_default", Number(this.state.searchData.int_default));
        // console.log('row["int_default"]', Number(row["int_default"]));
        // console.log(
        //   "this.state.searchData.int_default.length === 0",
        //   this.state.searchData.int_default.length === 0
        // );
        // console.log(
        //   'row["int_default"] && Number(row["int_default"])===Number(this.state.searchData.int_default)',
        //   row["int_default"] &&
        //     Number(row["int_default"]) ===
        //       Number(this.state.searchData.int_default)
        // );
        if (
          searchOpen === true &&
          (this.state.searchData.vac_storename.length === 0 ||
            (row["vac_storename"] &&
              row["vac_storename"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_storename.toLowerCase()
                ))) &&
          (this.state.searchData.int_default.length === 0 ||
            (row["int_default"] !== undefined &&
              Number(row["int_default"]) ===
                Number(this.state.searchData.int_default)))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {
          // console.log('searchRows on end of Function', searchRows)
        }
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchInputChangeTrim = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value.trim(),
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
      }
    );
  };

  handleARDonActionClick = (row) => {
    const bint_acid = row.bint_acid,
      EditStoreName = row.vac_storename,
      txtStoreName = row.vac_storename,
      chkDefaultStore = row.int_default,
      actionName = row.actionName;
    if (actionName === "Edit") {
      this.setState({
        formData: {
          ...this.state.formData,
          bint_acid,
          EditStoreName,
          txtStoreName,
          chkDefaultStore,
        },
      });
      window.scrollTo(0, 0);
      document.getElementById("txtStoreName").focus();
    } else if (actionName === "Delete") {
      this.DeleteData(EditStoreName);
    } else {
      // console.log("Else of handleARDonActionClick Executed");
      let rows = this.state.rows.filter((row) => {
        if (
          row.bint_acid !== bint_acid &&
          row.vac_storename !== txtStoreName &&
          row.int_default !== chkDefaultStore
        )
          return row;
      });
      const rowsCount = rows.length;
      this.setState({ rows, rowsCount });
    }
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["vac_storename"]);
    const EditStoreName = row.vac_storename;
    this.DeleteData(EditStoreName);
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_acid",
      "vac_storename",
      "vac_storename",
      "int_default",
    ]);
    const bint_acid = row.bint_acid,
      EditStoreName = row.vac_storename,
      txtStoreName = row.vac_storename,
      chkDefaultStore = row.int_default;

    this.setState({
      formData: {
        ...this.state.formData,
        bint_acid,
        EditStoreName,
        txtStoreName,
        chkDefaultStore,
      },
    });
    window.scrollTo(0, 0);
    document.getElementById("txtStoreName").focus();
  };

  //#endregion

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      this.SaveStoreMaster,
      this.clearInfo,
      () => {
        // this.DeleteDetail(bint_displayorderno, vac_headingvalue); delete pending this 2 value ?
      }
    );
  };
  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      {
        handleOnclickSave: this.SaveStoreMaster,
        handleOnclickNew: this.clearInfo,
      }

      // this.saveSales(true)
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chkDefaultStore"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateStoreMaster = () => {
    let result = false;
    if (this.state.formData.txtStoreName.length <= 0) {
      this.props.toastErrorMsg("Enter Store Name", "txtStoreName");
    } else {
      result = true;
    }
    return result;
  };

  getInfo = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "StoreList",
        bint_acid: localStorage.getItem("acid"),
      };
      // console.log("reqdata", reqData);
      fetchStoreMaster(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = res.data.StoreList,
            rowsCount = rows.length;
          this.setState(
            {
              dataLoadStatus,
              rowsCount,
              rows,
            },
            () => {
              this.props.updateStoreitemList &&
                this.props.updateStoreitemList(res.data.StoreList);
            }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txtStoreName").focus();
  };

  clearInfo = () => {
    const EditStoreName = "",
      txtStoreName = "",
      chkDefaultStore = "";

    this.setState(
      {
        formData: {
          ...this.state.formData,
          EditStoreName,
          txtStoreName,
          chkDefaultStore,
        },
      },
      () => {
        document.getElementById("txtStoreName").focus();
      }
    );
  };

  SaveStoreMaster = () => {
    if (this.validateStoreMaster()) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SaveStore",
          bint_acid: localStorage.getItem("acid"),
          edit_storename: this.state.formData.EditStoreName,
          vac_storename: this.state.formData.txtStoreName,
          int_default: this.state.formData.chkDefaultStore ? 1 : 0,
        };
        // console.log("reqdata",reqData);

        fetchStoreMaster(reqData)
          .then((res) => {
            // console.log("response", res);
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.getInfo();
              this.clearInfo(true);
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in SaveStore.", error);
          });
      });
    }
  };

  DeleteData = (EditStoreName) => {
    if (EditStoreName.length > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete Store : " + EditStoreName + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteStoreMaster(EditStoreName);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteStoreMaster = (edit_storename) => {
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus: false }, () => {
      const reqData = {
        Op: "DeleteStore",
        bint_acid: localStorage.getItem("acid"),
        edit_storename: edit_storename,
      };
      // console.log("reqdata", reqData);
      fetchStoreMaster(reqData)
        .then((res) => {
          // console.log("res", res.data);
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState({ ARD: null }, () => {
              this.getInfo();
              this.clearInfo(true);
            });
          } else {
            this.setState({ dataLoadStatus: true });
          }
        })
        .catch((error) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in delete DeleteStore. " + error
          );
        });
    });
    return false;
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "vac_storename",
        label: "Store Name",
        value: this.state.searchData.vac_storename,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "int_default",
        label: "Defaut Store",
        value: this.state.searchData.int_default,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {this.props.showHeading && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "30px", color: "#515151" }}
            >
              <b>Store Master</b>
            </label>
          </Grid>
        )}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtStoreName"
                  value={this.state.formData.txtStoreName}
                  label="Store Name*"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={100}
                />
              </Grid>
              <Grid item>
                <CtCheckBox
                  id="chkDefaultStore"
                  name="chkDefaultStore"
                  label="Default Store"
                  checked={this.state.formData.chkDefaultStore}
                  handleCheckChange={this.handleOnChkChange}
                ></CtCheckBox>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              marginTop={2}
            >
              <Grid item>
                <CtBtn
                  label="Save"
                  onClick={() => {
                    this.trimFormData(() => {
                      this.SaveStoreMaster();
                    });
                  }}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  onClick={this.clearInfo}
                  variant="outlined"
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  onClick={() => {
                    this.DeleteData(this.state.formData.EditStoreName);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        {/* <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          // toolTipNewEntry='New Product Entry'
        /> */}

        <CtART
          rowsdata={this.state.rows}
          columnsdata={this.state.columnsdata}
          rowsPerPage={this.state.rowsPerPage}
          tblmaxHeight={500}
          csvFileName={csvFileName("StoreMaster")}
          rowIconAction={[
            {
              label: "Edit",
              onClick: this.handleARDonActionClick_Edit,
              icon: "Edit",
              className: "secondary-button",
            },
            {
              label: "Delete",
              onClick: this.handleARDonActionClick_Delete,
              icon: "delete",
              className: "delete-button",
            },
            // this.props.userPrivilege["Entry:Proposal"] == "M"
            //   ? {
            //       label: "Delete",
            //       onClick: this.handleARDonActionClick_Delete,
            //       icon: "delete",
            //       className: "delete-button",
            //     }
            //   : "",
          ]}
          // tableButtonAction={[
          //   {
          //     label: "Sales Entry",
          //     onClick: this.handleOnNewEntryClick,
          //     addPluseIcon: true,
          //   },
          //   // this.props.userPrivilege["Entry:Proposal"] != "R"
          //   //   ? {
          //   //       label: "Add New Proposal",
          //   //       onClick: this.handleOnNewEntryClick,
          //   //       addPluseIcon: true,
          //   //     }
          //   //   : "",
          // ]}
          showColumnFilters={false}
          actionColSize={90}
          hideColIdList={["bint_srno", "int_default"]}
          density={"compact"}
        />

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(StoreMaster)));
